/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Person_InactiveInputs */

const fr_error_person_inactive = /** @type {(inputs: Error_Person_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’accès de ce collaborateur a été retiré. Rétablissez-le d’abord.`)
};

const en_error_person_inactive = /** @type {(inputs: Error_Person_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person's access has been withdrawn. Restore it first.`)
};

/**
* | output |
* | --- |
* | "This person's access has been withdrawn. Restore it first." |
*
* @param {Error_Person_InactiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_person_inactive = /** @type {((inputs?: Error_Person_InactiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Person_InactiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_person_inactive(inputs)
	return fr_error_person_inactive(inputs)
});